import { myAxios } from "./axios"

export function getDeductions(data, { page, perPage }) {
    let config = {
        params: {
            page,
            perPage,
            ...(data || {})

        },
    }
    return myAxios.get("/deductions", config)
}

export function getDeduction(id) {
    return myAxios.get("/deductions/" + id)
}

export function addDeduction(data) {
    return myAxios.post("/deductions/create", data)
}

export function editDeduction(id, data) {
    return myAxios.put("/deductions/" + id + "/update", data)
}

export function deleteDeduction(id) {
    return myAxios.delete("/deductions/" + id + "/delete")
}

